import {Component} from "../interface/component";

export class SelectricComponent implements Component {

    private $root:JQuery;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
    }

    init() {
        /* @ts-ignore */
        this.$root.selectric();
    }
}
